(() => {
  "use strict";
  var e,
    t = {
      9710: (e, t, n) => {
        var i = n(3058),
          o = n.n(i);
        function a(e, t) {
          return (
            (t = t || {}),
            (function (e) {
              if ("number" != typeof e)
                throw new TypeError("Theme Cart: Variant ID must be a number");
            })(e),
            (function (e, t, n) {
              var i = JSON.parse(
                JSON.stringify({
                  credentials: "same-origin",
                  headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json;",
                  },
                })
              );
              return (
                (i.method = "POST"),
                (i.body = JSON.stringify({
                  id: e,
                  quantity: parseInt($('input[name="quantity"]').val()),
                  properties: n,
                })),
                (function (e, t) {
                  return fetch(e, t).then(function (e) {
                    if (!e.ok) throw e;
                    return e.json();
                  });
                })("/cart/add.js", i)
              );
            })(e, t.quantity, t.properties)
          );
        }
        const r = function (e, t) {
          return new Promise(function (n) {
            if (!e.length)
              return void (function (e) {
                fetch("/cart.js", { credentials: "same-origin" })
                  .then((e) => e.json())
                  .then(function (t) {
                    let n = o()(".cart-icon__counter");
                    n.text(t.item_count),
                      t.item_count > 0
                        ? n.removeClass("d-none")
                        : n.addClass("d-none");
                    let i = o()(n).parent(),
                      a = i.clone();
                    a.removeClass("boa_cart_transition"),
                      a.addClass("boa_cart_transition"),
                      o()(i).replaceWith(a),
                      e(t);
                    let r = o()(".v2-cart-counter");
                    r.length && r.text(t.item_count),
                      t.item_count > 0
                        ? r.removeClass("d-none")
                        : r.addClass("d-none");
                  });
              })(n);
            const i = e.shift();
            i.options?.selling_plan_id
              ? (function (e, t, n, i) {
                  let o = {
                    items: [
                      {
                        id: n.id,
                        quantity: (n.options && n.options.quantity) || 1,
                        selling_plan: n.options.selling_plan_id,
                        properties: n.options.properties,
                      },
                    ],
                  };
                  fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(o),
                  })
                    .then((e) => e.json())
                    .then(function (o) {
                      c(n, o, i),
                        r(t, i).then(function (t) {
                          e(t);
                        });
                    });
                })(n, e, i, t)
              : (function (e, t, n, i) {
                  a(n.id, n.options).then(function (o) {
                    fetch("/cart.js")
                      .then((e) => e.json())
                      .then(function (o) {
                        c(n, o, i),
                          r(t, i).then(function (t) {
                            e(t);
                          });
                      });
                  });
                })(n, e, i, t);
          });
        };
        
        window.preDataLayer = window.preDataLayer || [];
        
        function c(e, t, n) {
          let i = (e.options && e.options.quantity) || 1;
          preDataLayer.push({
            event: "newEvent",
            newEventData: {
              ecommerce: {
                add: { list: n, products: [{ variant_id: e.id, quantity: i }] },
              },
              cart: {
                item_count: t.items.length,
                items: t.items,
                total_price: t.total_price,
              },
              type: "ecommerceData",
            },
          });
        }
        function s() {
          this.entries = [];
        }
        function l(e, t) {
          return (
            d(e),
            (function (e) {
              if (Array.isArray(e) && "object" == typeof e[0])
                throw new Error(e + "is not a valid array of options.");
            })(t),
            e.variants.filter(function (e) {
              return t.every(function (t, n) {
                return e.options[n] === t;
              });
            })[0] || null
          );
        }
        function d(e) {
          if ("object" != typeof e)
            throw new TypeError(e + " is not an object.");
          if (0 === Object.keys(e).length && e.constructor === Object)
            throw new Error(e + " is empty.");
        }
        (s.prototype.add = function (e, t, n) {
          this.entries.push({ element: e, event: t, fn: n }),
            e.addEventListener(t, n);
        }),
          (s.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (e) {
              return e.element.removeEventListener(e.event, e.fn), !1;
            });
          });
        function u(e, t, n) {
          (this.element = e),
            (this.product = (function (e) {
              if ("object" != typeof e)
                throw new TypeError(e + " is not an object.");
              if (void 0 === e.variants[0].options)
                throw new TypeError(
                  "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
                );
              return e;
            })(t)),
            (n = n || {}),
            (this._listeners = new s()),
            this._listeners.add(
              this.element,
              "submit",
              this._onSubmit.bind(this, n)
            ),
            (this.optionInputs = this._initInputs(
              '[name^="options"]',
              n.onOptionChange
            )),
            (this.quantityInputs = this._initInputs(
              '[name="quantity"]',
              n.onQuantityChange
            )),
            (this.propertyInputs = this._initInputs(
              '[name^="properties"]',
              n.onPropertyChange
            ));
        }
        (u.prototype.destroy = function () {
          this._listeners.removeAll();
        }),
          (u.prototype.options = function () {
            return (
              (e = this.optionInputs),
              (t = function (e) {
                return (
                  (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e
                );
              }),
              e.reduce(function (e, n) {
                return (
                  (n.checked ||
                    ("radio" !== n.type && "checkbox" !== n.type)) &&
                    e.push(t({ name: n.name, value: n.value })),
                  e
                );
              }, [])
            );
            var e, t;
          }),
          (u.prototype.variant = function () {
            return (function (e, t) {
              d(e);
              var n = (function (e, t) {
                d(e),
                  (function (e) {
                    if (!Array.isArray(e))
                      throw new TypeError(e + " is not an array.");
                    if (0 === e.length) return [];
                    if (!e[0].hasOwnProperty("name"))
                      throw new Error(e[0] + "does not contain name key.");
                    if ("string" != typeof e[0].name)
                      throw new TypeError(
                        "Invalid value type passed for name of option " +
                          e[0].name +
                          ". Value should be string."
                      );
                  })(t);
                var n = [];
                return (
                  t.forEach(function (t) {
                    for (var i = 0; i < e.options.length; i++)
                      if (
                        e.options[i].name.toLowerCase() === t.name.toLowerCase()
                      ) {
                        n[i] = t.value;
                        break;
                      }
                  }),
                  n
                );
              })(e, t);
              return l(e, n);
            })(this.product, this.options());
          }),
          (u.prototype.properties = function () {
            var e,
              t,
              n =
                ((e = this.propertyInputs),
                (t = function (e) {
                  return /(?:^(properties\[))(.*?)(?:\])/.exec(e)[2];
                }),
                e.reduce(function (e, n) {
                  return (
                    (n.checked ||
                      ("radio" !== n.type && "checkbox" !== n.type)) &&
                      (e[t(n.name)] = n.value),
                    e
                  );
                }, {}));
            return 0 === Object.entries(n).length ? null : n;
          }),
          (u.prototype.quantity = function () {
            return this.quantityInputs[0]
              ? Number.parseInt(this.quantityInputs[0].value, 10)
              : 1;
          }),
          (u.prototype._setIdInputValue = function (e) {
            var t = this.element.querySelector('[name="id"]');
            t ||
              (((t = document.createElement("input")).type = "hidden"),
              (t.name = "id"),
              this.element.appendChild(t)),
              (t.value = e.toString());
          }),
          (u.prototype._onSubmit = function (e, t) {
            (t.dataset = this._getProductFormEventData()),
              t.dataset.variant && this._setIdInputValue(t.dataset.variant.id),
              e.onFormSubmit && e.onFormSubmit(t);
          }),
          (u.prototype._onFormEvent = function (e) {
            return void 0 === e
              ? Function.prototype
              : function (t) {
                  (t.dataset = this._getProductFormEventData()), e(t);
                }.bind(this);
          }),
          (u.prototype._initInputs = function (e, t) {
            return Array.prototype.slice
              .call(this.element.querySelectorAll(e))
              .map(
                function (e) {
                  return (
                    this._listeners.add(e, "change", this._onFormEvent(t)), e
                  );
                }.bind(this)
              );
          }),
          (u.prototype._getProductFormEventData = function () {
            return {
              options: this.options(),
              variant: this.variant(),
              properties: this.properties(),
              quantity: this.quantity(),
            };
          });
        var p = n(1903),
          m = (n(3892), n(8928));
        const h = document.currentScript.getAttribute("section-id"),
          v = JSON.parse(
            document.querySelector(`[data-settings-id='${h}']`).innerHTML
          );
        (window.machinePDP.currentViewProduct = JSON.parse(
          o()("#pdp-product-json").html()
        )),
          (window.machinePDP.currentSelectedVariant = ""),
          (window.machinePDP.variantExist = !0);
        let f = !1,
          y = !1,
          w = !1,
          g = 6,
          b = !1,
          S = { enabled: !1, video: null, autoplay: !1 };
        const L = window.machinePDP.termsCheckbox;
        function E() {
          let pack = document.querySelector(".machine-pdp-deal-variant input[type=radio]:checked");
          if (!pack) return;
          let e = document.querySelector(".tab-view-bundle-content"),
            t = pack.nextElementSibling.querySelector(
                ".slider-view-bundle-content"
              ).innerHTML;
          e.classList.remove("show-more-available", "is-expanded"),
            e.classList.add("remove-transitions"),
            (e.innerHTML = t);
          let n = e.scrollHeight - e.clientHeight;
          (e.children.length > g || n > 25) &&
            (1 == window.machinePDP.variantSettings.add_btn_show_all_show_less
              ? e.classList.add("show-more-available")
              : e.classList.add("is-expanded")),
            e.classList.remove("remove-transitions");
        }
        function q() {
          let e = document.querySelector(".pdp-atc"),
            t = e && e.querySelector(".pdp-bundle-name"),
            n = window.machinePDP.currentSelectedVariant,
            pack = document.querySelector(".machine-pdp-deal-variant input[type=radio]:checked"),
            holder = document.querySelector(".pdp-atc-holder");
          if (!e) return;
          if (!pack) {
            e.disabled = "disabled";
            if (t) t.innerHTML = "";
            if (holder) holder.classList.add("pdp-atc-disabled");
            return;
          }
          n && n.available ? (e.disabled = "") : (e.disabled = "disabled"),
            t && (t.innerHTML = pack.value);
          if (holder && !(L.available && L.required && !L.checked)) holder.classList.remove("pdp-atc-disabled");
        }
        function k() {
          let e = window.machinePDP.currentSelectedVariant;
          if (!e) return;
          const t = (function (e, t) {
            return /variant=/.test(e)
              ? e.replace(/(variant=)[^&]+/, "$1" + t)
              : /\?/.test(e)
              ? e.concat("&variant=").concat(t)
              : e.concat("?variant=").concat(t);
          })(window.location.href, e.id);
          window.history.replaceState({ path: t }, "", t);
        }
        function P() {
  let e = document.querySelector(".machine-pdp-deal-variant");
  if (!e) return;
  let machineInput = document.querySelector(".machine-pdp-color-variant input[type=radio]:checked");
  if (!machineInput) return;
  let t = machineInput.value;

  e.querySelectorAll("input").forEach(function (inputEl) {
    let botellaInput = document.querySelector(".machine-pdp-bottle-variant input[type=radio]:checked");
    let botella = botellaInput ? botellaInput.value : "";
    let variant = l(window.machinePDP.currentViewProduct, [t, botella, inputEl.value]);

    let label = inputEl.nextElementSibling;
    let bundleContent = "";
    let a = label.querySelector(".slider-view-bundle-content");
    let r = label.querySelector(".variant-bundle-price");
    let c = label.querySelector(".variant-bundle-old-price");
    let p = label.querySelector(".variant-bundle-percent");
    if (!a || !r) return;

    // Limpiar contenido
    a.innerHTML = "";
    r.innerHTML = "";
    c && (c.innerHTML = "");
    p && (p.innerHTML = "");
    a.classList.add("remove-transitions");
    label.classList.remove("out-of-stock", "pushed-back", "not-exist");
    a.classList.remove("show-more-available", "is-expanded");

    if (!variant) {
      label.classList.add("not-exist", "pushed-back");
      a.innerHTML = window.machinePDP.bundleDoesNotExistText;
      return;
    }

    if (!variant.available) {
      label.classList.add("out-of-stock", "pushed-back");
    }

    r.innerHTML = formatMoney(variant.price);

    if (variant.compare_at_price > 0) {
      c.innerHTML = formatMoney(variant.compare_at_price);
      p.innerHTML = Math.round(
        ((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100
      ) + "% OFF";
      p.classList.remove("d-none");
    } else {
      c.innerHTML = "";
      p.classList.add("d-none");
    }

    if (window.machinePDP.variantBlockSettings) {
      window.machinePDP.variantBlockSettings.forEach(function (block) {
        if (block.settings.bundle_sku == variant.sku) {
          bundleContent = block.settings.bundle_content || "";
        }
      });
    }

    a.innerHTML = bundleContent;

    let extraHeight = a.scrollHeight - a.clientHeight;
    if (a.children.length > g || extraHeight > 25) {
      a.classList.add("show-more-available");
    }
    a.classList.remove("remove-transitions");
  });
}
        function getPreviewVariant() {
          let colorEl = document.querySelector(".machine-pdp-color-variant input[type=radio]:checked, input[name='options[Color]']:checked, input[name='options[Sabor]']:checked");
          let bottleEl = document.querySelector(".machine-pdp-bottle-variant input[type=radio]:checked, input[name='options[Botella]']:checked");
          if (!colorEl) return null;
          let color = colorEl.value,
            bottle = bottleEl ? bottleEl.value : "",
            variants = window.machinePDP.currentViewProduct.variants;
          return (
            variants.find(function (v) {
              return v.options[0] === color && (!bottle || v.options[1] === bottle) && v.available;
            }) ||
            variants.find(function (v) {
              return v.options[0] === color && (!bottle || v.options[1] === bottle);
            }) ||
            null
          );
        }
        function _() {
          let e = document.querySelector(".machine-pdp-color-variant input[type=radio]:checked, input[name='options[Color]']:checked, input[name='options[Sabor]']:checked");
          let b = document.querySelector(".machine-pdp-bottle-variant input[type=radio]:checked, input[name='options[Botella]']:checked");
          let p = document.querySelector(".machine-pdp-deal-variant input[type=radio]:checked") || document.querySelector("input[name='options[Pack]']:checked");
        
          let color = e ? e.value : "";
          let botella = b ? b.value : "";
          let pack = p ? p.value : "";

          if (!p) {
            window.machinePDP.currentSelectedVariant = "";
            window.machinePDP.variantExist = false;
            window.machinePDP.previewVariant = getPreviewVariant();
            return;
          }
          window.machinePDP.previewVariant = "";

          // Si no hay botella seleccionado, evitar error
          let options = [color, botella, pack];
        
          window.machinePDP.currentSelectedVariant = l(window.machinePDP.currentViewProduct, options);
        
          if (window.machinePDP.currentSelectedVariant) {
            document.querySelector(".product-form-selector").value = window.machinePDP.currentSelectedVariant.id;
            window.machinePDP.variantExist = true;
        
            const form = document.querySelector('form[data-product-form]');
            let existing = form.querySelector('input[name="properties[Envio]"]');
            const vid = window.machinePDP.currentSelectedVariant.id;
        
            if (window.delayVariants[vid]) {
              if (!existing) {
                const i = document.createElement('input');
                i.type = 'hidden';
                i.name = 'properties[Envio]';
                i.value = 'Personalizado';
                form.appendChild(i);
              }
            } else {
              if (existing) existing.remove();
            }
        
            const event = new CustomEvent("onVariantChange", { detail: { variant: window.machinePDP.currentSelectedVariant } });
            document.dispatchEvent(event);
          } else {
            window.machinePDP.variantExist = false;
          }
        }

        function x() {
          let e = window.machinePDP.currentSelectedVariant || window.machinePDP.previewVariant;
          if (!e) return;
          e && document.querySelector("[data-variant-id='" + e.id + "'")
            ? (document
                .querySelector(".machine-pdp-images-container")
                .classList.remove("gallery-not-exist"),
              document
                .querySelectorAll(".single-item-image")
                .forEach(function (t) {
                  t.dataset.variantId == e.id
                    ? t.classList.add("d-flex")
                    : t.classList.remove("d-flex");
                }))
            : document
                .querySelector(".machine-pdp-images-container")
                .classList.add("gallery-not-exist"),
            D.update();
        }
        if (
          (window.innerWidth < 992 && ((y = !0), (w = !0), (g = 4)),
          1 ==
            document.querySelectorAll(".machine-pdp-deal-variant label")
              .length &&
            ((b = !0),
            document
              .querySelector(".machine-pdp-deal-variant")
              .classList.add("single-bundle")),
          document.querySelector(".machine-pdp-variant-tabs") &&
            (document.querySelectorAll(".machine-pdp-variant-tabs label")
              .length > 3 || window.innerWidth < 992
              ? (document
                  .querySelector(".machine-pdp-variant-tabs")
                  .classList.add("machine-pdp-variant-slider"),
                document
                  .querySelector(".machine-pdp-variant-tabs")
                  .classList.remove("machine-pdp-variant-tabs"),
                (f = !1))
              : (f = !0)),
          v.is_vimeo &&
            (S = {
              enabled: !0,
              video: new m.Z(document.querySelector(".pdp-vimeo")),
              autoplay: v.autoplay,
            }),
          document.addEventListener("DOMContentLoaded", function () {
            document
              .querySelector(".machine-pdp-options-container")
              .querySelectorAll('input[type="radio"]')
              .forEach(function (e) {
                e.addEventListener("click", function (e) {
                  _(),
                  x(),
                  q(),
                  window.machinePDP.variantExist && k(),
                  (
                    e.target.closest(".machine-pdp-color-variant") ||
                    e.target.closest(".machine-pdp-bottle-variant") ||
                    "options[Color]" == e.target.getAttribute("name") ||
                    "options[Sabor]" == e.target.getAttribute("name") ||
                    "options[Botella]" == e.target.getAttribute("name")
                  ) && P(),
                  f && E();
                });
              }),
              L.available &&
                (function () {
                  const e = document.querySelector(".pdp-atc-holder");
                  L.required &&
                    (L.element.addEventListener("click", function () {
                      (L.checked = this.checked),
                        this.checked
                          ? e.classList.remove("pdp-atc-error")
                          : e.classList.add("pdp-atc-disabled"),
                        q();
                    }),
                    L.checked || e.classList.add("pdp-atc-disabled"));
                })(),
              (function () {
  let e = document.querySelector(".machine-pdp-color-variant"),
      t = document.querySelector(".machine-pdp-deal-variant");
  e.querySelectorAll("input").forEach(function (e) {
    let n = e.value,
        i = [];

    // Detectar si Botella está seleccionada
    let botellaInput = document.querySelector("input[name='options[Botella]']:checked");
    let botella = botellaInput ? botellaInput.value : null;

    // Si NO hay botella seleccionada, no marcar nada como agotado
    if (!botella) {
      e.disabled = false;
      e.closest(".variant-option").classList.remove("crossed-out");
      return;
    }

    // Si hay botella, verificar combinaciones completas
    t.querySelectorAll("input").forEach(function (e) {
      let t = e.value,
          o = l(window.machinePDP.currentViewProduct, [n, botella, t]);
      o && o.available && i.push(e);
    });

    // Si no hay ninguna combinación válida, marcar como agotado
    if (i.length === 0) {
      e.disabled = true;
      e.closest(".variant-option").classList.add("crossed-out");
    } else {
      e.disabled = false;
      e.closest(".variant-option").classList.remove("crossed-out");
    }
  });
})();
              (function () {
                let radios = document.querySelectorAll(".machine-pdp-deal-variant input[type=radio]");
                if (radios.length === 1) radios[0].checked = true;
              })(),
              _(),
              P(),
              x(),
              q(),
              k(),
              f && E(),
              document
                .querySelectorAll(".slider-view-bundle-content")
                .forEach(function (e) {
                  let t = e
                    .closest(".slider-view-bundle-content-wrap")
                    .querySelector(".toggle-button");
                  t?.addEventListener("click", function (n) {
                    e.classList.contains("show-more-available") &&
                      !this.classList.contains("dont-activate-click") &&
                      (j("", "show more/show less slider pdp"),
                      e.classList.toggle("is-expanded"),
                      t.classList.toggle("is-expanded")),
                      n.defaultPrevented &&
                        (this.closest("label").previousElementSibling.click(),
                        (this.closest("label").previousElementSibling.checked =
                          !0));
                  });
                }),
              f &&
                document
                  .getElementsByClassName("tab-view-bundle-content")[0]
                  .addEventListener("click", function (e) {
                    this.classList.contains("show-more-available") &&
                      (this.classList.toggle("is-expanded"),
                      j("", "show more/show less tab pdp"));
                  }),
              (function () {
                let e = document.getElementsByClassName("desktop-read-more")[0],
                  t = document.getElementsByClassName("mobile-read-more")[0],
                  n = document.getElementsByClassName("desktop-read-less")[0],
                  i = document.getElementsByClassName("mobile-read-less")[0],
                  o = document.querySelector(".read-more-less-desktop-text"),
                  a = document.querySelector(".read-more-less-mobile-text");
                e &&
                  e.addEventListener("click", function () {
                    e.classList.contains("hide-important") ||
                      (e.classList.add("hide-important"),
                      n.classList.remove("hide-important"),
                      o.classList.remove("partially-hide-description"));
                  }),
                  n &&
                    n.addEventListener("click", function () {
                      n.classList.contains("hide-important") ||
                        (n.classList.add("hide-important"),
                        e.classList.remove("hide-important"),
                        o.classList.add("partially-hide-description"));
                    }),
                  t &&
                    t.addEventListener("click", function () {
                      t.classList.contains("hide-important") ||
                        (t.classList.add("hide-important"),
                        i.classList.remove("hide-important"),
                        a.classList.remove("partially-hide-description"));
                    }),
                  i &&
                    i.addEventListener("click", function () {
                      i.classList.contains("hide-important") ||
                        (i.classList.add("hide-important"),
                        t.classList.remove("hide-important"),
                        a.classList.add("partially-hide-description"));
                    });
              })(),
              (function () {
                let e = document.querySelector(
                  ".machine-pdp-images-container"
                ).clientWidth;
                (document.querySelector(".pdp-machine-gallery").style.height =
                  e + "px"),
                  (document.querySelector(".pdp-images-gallery").style.height =
                    e + "px"),
                  (document.querySelector(".pdp-images-gallery").style.width =
                    e + "px"),
                  document
                    .querySelectorAll(
                      ".machine-pdp-main-section model-viewer"
                    )
                    .forEach(function (n) {
                      n.style.height = e + "px";
                    }),
                  (document.querySelector(
                    ".pdp-variant-not-exist"
                  ).style.height = e + "px"),
                  document.querySelector(".pdp-gallery-selector") &&
                    (document.querySelector(
                      ".pdp-gallery-selector"
                    ).style.height = e + "px");
                let t = document.querySelectorAll(
                    ".machine-pdp-gallery-opener"
                  ),
                  n = document.querySelectorAll(".pdp-gallery-holder");
                t.forEach(function (e) {
                  let i = e.dataset.target;
                  e.addEventListener("click", function () {
                    S.enabled &&
                      ("gallery-video" == i
                        ? S.autoplay && S.video.play()
                        : S.video.pause()),
                      t.forEach(function (t) {
                        t.classList.remove("selected"),
                          t === e && t.classList.add("selected");
                      }),
                      n.forEach(function (e) {
                        e.classList.remove("d-flex"),
                          e.dataset.window === i && e.classList.add("d-flex");
                      });
                  });
                });
              })(),
              (function () {
                let e = y
                    ? document.querySelector(".info-tabs-reviews-tab-wrapper")
                    : document.querySelector(
                        "[data-info-tabs-source='reviews']"
                      ),
                  t = y
                    ? document.querySelector(
                        ".mobile-machine-information .pdp-block-review"
                      )
                    : document.querySelector(
                        ".desktop-machine-information .pdp-block-review"
                      );
                e &&
                  t &&
                  t.addEventListener("click", function (t) {
                    e.classList.contains("active") || e.click(),
                      e.scrollIntoView({ behavior: "smooth" }),
                      j("", "machine pdp review score");
                  });
              })(),
              (function () {
                const e = document.getElementById("infoMetafieldsMobile"),
                  t = o()("#machineTooltipsModal"),
                  n = new p.Z("#machineTooltipsModal .swiper", {
                    slidesPerView: "1",
                    rewind: !0,
                    navigation: {
                      prevEl: "#tooltipModalPrev",
                      nextEl: "#tooltipModalNext",
                    },
                  });
                e &&
                  Array.from(e.children).forEach((e) => {
                    e.addEventListener("click", () => {
                      t.data("activeSwiper", e.dataset.metafieldIndex),
                        t.modal("show");
                    });
                  }),
                  t.on("shown.bs.modal", function () {
                    n.slideTo(t.data("activeSwiper"), 0);
                  });
              })(),
              document.querySelector("#upsellModalCart") ||
                (function () {
                  const e = document.querySelector(".pdp-atc-holder");
                    document.querySelector(".pdp-atc").onclick = function (t) {
                      t.preventDefault();
                      if (
                        !L.available ||
                        (L.available && L.required && L.checked) ||
                        (L.available && !L.required)
                      ) {
                        const formElement = document.querySelector('form[data-product-form]');
                        const productForm = new u(formElement, window.machinePDP.currentViewProduct);
                        
                        const properties = productForm.properties();
                        
                        let e = {
                          id: window.machinePDP.currentSelectedVariant.id,
                          options: {
                            properties: properties, // Incluir las propiedades
                          },
                        };
                        
                        if (
                          window.machinePDP?.currentSelectedVariant?.selling_plan_allocations?.length > 0
                        ) {
                          e.options.selling_plan_id =
                            window.machinePDP.currentSelectedVariant.selling_plan_allocations[0].selling_plan_id;
                        }
                        
                        r([e], null).then(async function () {
                          await updateCartDrawer();
                          setTimeout(openCartDrawer, 500)();
                        });
                      }
                      if (L.available && L.required && !L.checked) {
                        document.querySelector(".pdp-atc-holder").classList.add("pdp-atc-error");
                      }
                    };
                })(),
              (function () {
                let e = v.bundle_redirect_name,
                  t = v.bundle_redirect_title,
                  n = v.bundle_redirect_url,
                  i = v.enable_bundle_redirect;
                if (window.machinePDP && i) {
                  let o = e.toLowerCase().replace(" ", "-"),
                    a = document.createElement("a");
                  (a.innerText = t),
                    a.classList.add(
                      "w-100",
                      "d-none",
                      "mt-20",
                      "mb-20",
                      "bg-black-pearl",
                      "text-center",
                      "text-uppercase",
                      "text-white",
                      "fs17",
                      "pdp-redirect"
                    ),
                    (a.href = n);
                  let r = document.querySelector(".pdp-atc");
                  function c() {
                    a.classList.add("d-block"),
                      r.classList.remove("d-block"),
                      r.classList.add("d-none");
                  }
                  i &&
                    (document.querySelector(".pdp-atc-holder").appendChild(a),
                    document
                      .querySelectorAll('[data-value="' + o + '"]')
                      .forEach(function (e) {
                        e.querySelector(".variant-bundle-prices").classList.add(
                          "d-none"
                        );
                      }),
                    window.machinePDP.currentSelectedVariant.option2 == e &&
                      c(),
                    document.addEventListener("onVariantChange", function (t) {
                      t.detail.variant.option2 == e
                        ? c()
                        : (a.classList.remove("d-block"),
                          r.classList.remove("d-none"),
                          r.classList.add("d-block"));
                    }));
                }
              })();
          }),
          !f && !b)
        ) {
          const e = new p.Z(
            ".machine-pdp-options-container .machine-pdp-deal-variant",
            {
              slidesPerView: "auto",
              spaceBetween: 15,
              rewind: !0,
              allowTouchMove: w,
              centeredSlides: !0,
              centeredSlidesBounds: !0,
              pagination: {
                el: ".machine-pdp-options-container .pdp-bundles-pagination",
                type: "bullets",
                clickable: !0,
              },
              navigation: {
                prevEl: ".machine-pdp-options-container .pdp-bundle-prev",
                nextEl: ".machine-pdp-options-container .pdp-bundle-next",
              },
            }
          );
          e.on("touchStart", function () {
            window.machinePDP._packSliderUserMoved = !0;
          });
          document
            .querySelectorAll(
              ".machine-pdp-options-container .pdp-bundle-prev, .machine-pdp-options-container .pdp-bundle-next, .machine-pdp-options-container .pdp-bundles-pagination"
            )
            .forEach(function (el) {
              el.addEventListener(
                "click",
                function () {
                  window.machinePDP._packSliderUserMoved = !0;
                },
                !0
              );
            });
          e.on("slideChange", function () {
            if (!window.machinePDP._packSliderReady) return;
            this.isEnd
              ? this.el.classList.add("pdp-slider-end")
              : this.el.classList.remove("pdp-slider-end");
            this.isBeginning
              ? this.el.classList.add("pdp-slider-start")
              : this.el.classList.remove("pdp-slider-start");
          });
          let t = document.querySelector(".machine-pdp-deal-variant input[type=radio]:checked");
          if (t) e.slideTo(t.dataset.valuePosition);
          window.machinePDP._packSliderReady = !0;
        }
        let D, C, T;
        function j(e, t) {
          preDataLayer.push({
            event: "newEvent",
            newEventData: { type: "Click", elementType: t, elementId: e },
          });
        }
        israelShop
          ? ((C = ".machine-pdp-main-section .pdp-gallery-prev"),
            (T = ".machine-pdp-main-section .pdp-gallery-next"))
          : ((T = ".machine-pdp-main-section .pdp-gallery-prev"),
            (C = ".machine-pdp-main-section .pdp-gallery-next")),
          (D = y
            ? new p.Z(".machine-pdp-main-section .pdp-images-gallery", {
                direction: "horizontal",
                slidesPerView: 1,
                rewind: !0,
                navigation: { prevEl: T, nextEl: C },
              })
            : new p.Z(".machine-pdp-main-section .pdp-images-gallery", {
                direction: "horizontal",
                slidesPerView: 1,
                rewind: !0,
              })),
          D.on("touchEnd", function () {
            let e = D.touches.diff < 0 ? "next" : "previous";
            window.preDataLayer.push({
              event: "newEvent",
              newEventData: {
                type: "Engagement",
                elementType: "Image gallery scroll",
                elementId: e,
              },
            });
          }),
          D.on("scroll", function () {
            window.preDataLayer.push({
              event: "newEvent",
              newEventData: {
                type: "Engagement",
                elementType: "Image gallery scroll",
                elementId: "mousewheel",
              },
            });
          });
        let I = document.getElementsByClassName("desktop-read-more")[0],
          M = document.getElementsByClassName("desktop-read-less")[0];
        I?.addEventListener("click", function () {
          j("Read more", "New Sparkling Water Maker Description");
        }),
          M?.addEventListener("click", function () {
            j("Read less", "New Sparkling Water Maker Description");
          });
      },
    },
    n = {};
  function i(e) {
    var o = n[e];
    if (void 0 !== o) return o.exports;
    var a = (n[e] = { exports: {} });
    return t[e].call(a.exports, a, a.exports, i), a.exports;
  }
  (i.m = t),
    (e = []),
    (i.O = (t, n, o, a) => {
      if (!n) {
        var r = 1 / 0;
        for (d = 0; d < e.length; d++) {
          for (var [n, o, a] = e[d], c = !0, s = 0; s < n.length; s++)
            (!1 & a || r >= a) && Object.keys(i.O).every((e) => i.O[e](n[s]))
              ? n.splice(s--, 1)
              : ((c = !1), a < r && (r = a));
          if (c) {
            e.splice(d--, 1);
            var l = o();
            void 0 !== l && (t = l);
          }
        }
        return t;
      }
      a = a || 0;
      for (var d = e.length; d > 0 && e[d - 1][2] > a; d--) e[d] = e[d - 1];
      e[d] = [n, o, a];
    }),
    (i.n = (e) => {
      var t = e && e.__esModule ? () => e.default : () => e;
      return i.d(t, { a: t }), t;
    }),
    (i.d = (e, t) => {
      for (var n in t)
        i.o(t, n) &&
          !i.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (i.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (i.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t)),
    (() => {
      var e = { 5160: 0 };
      i.O.j = (t) => 0 === e[t];
      var t = (t, n) => {
          var o,
            a,
            [r, c, s] = n,
            l = 0;
          if (r.some((t) => 0 !== e[t])) {
            for (o in c) i.o(c, o) && (i.m[o] = c[o]);
            if (s) var d = s(i);
          }
          for (t && t(n); l < r.length; l++)
            (a = r[l]), i.o(e, a) && e[a] && e[a][0](), (e[a] = 0);
          return i.O(d);
        },
        n = (self.webpackChunk = self.webpackChunk || []);
      n.forEach(t.bind(null, 0)), (n.push = t.bind(null, n.push.bind(n)));
    })();
  var o = i.O(void 0, [5950, 2472, 6216, 7821, 6933], () => i(9710));
  o = i.O(o);
})();
